import styled from "styled-components";

export const TitleContainer = styled.div`
  padding: 24px;
  line-height: 32px;
  font-size: 20px;
  text-align: center;
`;
